/** @format */

import React, { memo } from 'react';

import { FormattedMessage } from 'gatsby-plugin-intl';

import { TTranslation } from '../../i18n/declarations';

type Props = { text: TTranslation | string; intlFormatter?: boolean | false };

export const UIText = memo(({ text, intlFormatter }: Props) => {
  if (intlFormatter) return <FormattedMessage id={text} />;
  return <>{text}</>;
});
